import { Product } from "@dashboard/modules/products/types/products.types";
import {
  Kit,
  KitDiscount,
  KitImageFormItem,
  KitProductFormItem,
} from "../types/kits.types";
import { DEFAULT_KIT_DISCOUNT_PERCENTAGE } from "../constants/kits.constants";

export type KitsUiState = {
  loading: boolean;
  saving: boolean;
  searchTerm: string;
  selectedCategoryId: string | null;
  showDeleteConfirmation: boolean;
};

export type KitsDataState = {
  kits: Kit[];
  selectedProducts: Product[];
  formProducts: KitProductFormItem[];
  formImages: KitImageFormItem[];
  formName: string;
  formDiscount: KitDiscount;
  editingKitId: string | null;
};

export type KitsState = {
  ui: KitsUiState;
  data: KitsDataState;
};

export const initialKitsState: KitsState = {
  ui: {
    loading: false,
    saving: false,
    searchTerm: "",
    selectedCategoryId: null,
    showDeleteConfirmation: false,
  },
  data: {
    kits: [],
    selectedProducts: [],
    formProducts: [],
    formImages: [],
    formName: "",
    formDiscount: {
      discountType: "percentage",
      discountValue: DEFAULT_KIT_DISCOUNT_PERCENTAGE,
    },
    editingKitId: null,
  },
};
